// 用户管理模块国际化 - 中文
export default {
  search: {
    placeholder: '搜索用户名、邮箱或手机号',
    status: '状态筛选',
    role: '角色筛选',
    all: '全部',
    enabled: '启用',
    disabled: '禁用',
    pending: '待激活',
    allRoles: '全部角色',
    admin: '管理员',
    user: '普通用户',
    refresh: '刷新',
    add: '添加用户',
    button: '搜索'
  },
  stats: {
    total: '总用户数',
    active: '正常用户',
    inactive: '禁用用户',
    pending: '待激活用户',
    normal: '正常用户',
    disable: '禁用用户'
  },
  table: {
    title: '用户列表',
    id: '用户ID',
    info: '用户信息',
    phone: '手机号',
    enterprise: '所属企业',
    role: '角色',
    status: '状态',
    lastLogin: '最后登录',
    createdAt: '创建时间',
    actions: '操作',
    detail: '详情',
    edit: '编辑',
    more: '更多',
    disableUser: '禁用用户',
    enableUser: '启用用户',
    bindCompany: '绑定企业',
    resetPassword: '重置密码',
    disable: '禁用',
    enable: '启用'
  },
  modal: {
    addTitle: '添加用户',
    editTitle: '编辑用户',
    detailTitle: '用户详情',
    bindTitle: '绑定企业',
    statusTitle: '用户状态确认',
    resetTitle: '重置密码确认',
    resetSuccess: '密码重置成功',
    ok: '确定',
    cancel: '取消',
    confirm: '确认',
    confirmBind: '确定绑定',
    confirmReset: '确认重置',
    currentUser: '当前用户',
    currentEnterprise: '当前企业',
    currentRole: '当前企业内角色',
    targetEnterprise: '目标企业',
    statusConfirm: {
      enable: '确定要启用用户',
      disable: '确定要禁用用户',
      enableDesc: '启用后，该用户将恢复正常的系统访问权限，可以重新登录使用系统。',
      disableDesc: '禁用后，该用户将无法登录系统，所有正在进行的操作将被中断。',
      info: '用户信息',
      enterprise: '所属企业',
      currentStatus: '当前状态',
      warning: '禁用警告',
      enableTip: '启用说明'
    },
    resetConfirm: {
      desc: '将会重置用户 {username} 的登录密码，是否确认？',
      tip: '注意：密码重置后将生成随机8位密码，并自动发送至用户邮箱',
      success: '密码重置信息已自动发送至用户邮箱 {email}',
      newPwd: '新密码',
      userEmail: '用户邮箱'
    }
  },
  form: {
    username: '用户名',
    email: '邮箱',
    phone: '手机号',
    enterprise: '所属企业',
    usernameRequired: '请输入用户名',
    usernameMin: '用户名至少2个字符',
    usernameMinLength: '用户名至少2个字符',
    usernamePlaceholder: '请输入用户名',
    emailRequired: '请输入邮箱',
    emailValid: '请输入有效的邮箱地址',
    emailPlaceholder: '请输入邮箱',
    phoneRequired: '请输入手机号',
    phoneMax: '手机号最大20个字符',
    phoneValid: '请输入有效的手机号',
    phonePlaceholder: '请输入手机号',
    enterpriseRequired: '请选择所属企业',
    enterprisePlaceholder: '请选择所属企业',
    targetEnterpriseRequired: '请选择要绑定的企业'
  },
  message: {
    refresh: '数据已刷新',
    showAll: '显示全部用户',
    showActive: '筛选启用用户',
    showInactive: '筛选禁用用户',
    showPending: '筛选待激活用户',
    getStatsFail: '获取用户统计失败',
    getListFail: '获取用户列表失败',
    getEnterpriseFail: '获取企业列表失败',
    getDetailFail: '获取用户详情失败',
    updateStatusFail: '修改用户状态失败',
    bindFail: '绑定企业失败',
    updateFail: '更新用户失败',
    addFail: '添加用户失败',
    resetFail: '重置密码失败',
    updateSuccess: '用户信息已更新',
    addSuccess: '用户已添加',
    bindSuccess: '已成功为用户 {username} 绑定企业：{enterprise}',
    statusSuccess: '用户 {username} 已{action}',
    resetSuccess: '密码重置成功',
    autoFilter: '已自动筛选企业：{company}',
    getCustomerEnterpriseFail: '查询企业信息失败'
  },
  role: {
    admin: '管理员',
    user: '普通用户',
    unknown: '未知'
  },
  status: {
    normal: '正常',
    disabled: '禁用',
    pending: '待激活',
    unknown: '未知'
  },
  // 新增统一命名风格和缺失 key
  filter: {
    status: '状态',
    role: '角色',
    all: '全部',
    enable: '启用',
    disable: '禁用',
    pending: '待激活',
    allRoles: '全部角色',
    admin: '管理员',
    user: '普通用户'
  },
  addUser: {
    button: '添加用户'
  },
  refresh: {
    button: '刷新'
  },
  edit: {
    editTitle: '编辑用户',
    addTitle: '添加用户',
    role: '角色',
    status: '状态',
    enterprise: '所属企业',
    confirm: '确认',
    cancel: '取消'
  },
  detail: {
    title: '用户详情',
    avatar: '头像',
    username: '用户名',
    email: '邮箱',
    phone: '手机号',
    enterprise: '所属企业',
    role: '角色',
    status: '状态',
    lastLogin: '最后登录',
    createdAt: '创建时间',
    userId: '用户ID',
    confirm: '确定'
  },
  bindCompany: {
    title: '绑定企业',
    currentUser: '当前用户',
    currentEnterprise: '当前企业',
    notBound: '未绑定',
    currentRole: '当前角色',
    targetEnterprise: '目标企业',
    enterpriseRequired: '请选择企业',
    enterprisePlaceholder: '请选择企业',
    confirmBind: '确定绑定',
    cancel: '取消'
  },
  toggleStatus: {
    confirmTitle: '状态切换确认',
    confirmMessage: '确定要切换用户 {username} 的状态为{action}吗？',
    disableWarning: '禁用警告',
    disableDescription: '禁用后用户将无法登录系统。',
    enableDescription: '启用后用户可正常登录系统。',
    userInfo: '用户信息',
    enterprise: '所属企业',
    currentStatus: '当前状态',
    cancel: '取消',
    disable: '禁用',
    enable: '启用'
  },
  resetPassword: {
    confirmTitle: '重置密码确认',
    warningTitle: '重置密码警告',
    confirmMessage: '确定要重置用户 {username} 的密码吗？',
    note: '重置后新密码将通过邮件发送给用户。',
    cancel: '取消',
    confirm: '确认',
    successTitle: '密码重置成功',
    successMessage: '密码已重置',
    username: '用户名',
    newPassword: '新密码',
    email: '邮箱',
    successInfo: '新密码已发送至邮箱 {email}'
  }
}